<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.4 1.01975C6.62 1.32975 3 5.51975 3 10.3097V16.9997C3 18.6597 4.34 19.9997 6 19.9997H7C8.1 19.9997 9 19.0997 9 17.9997V13.9997C9 12.8997 8.1 11.9997 7 11.9997H5V10.2897C5 6.44975 7.96 3.10975 11.79 2.99975C15.76 2.88975 19 6.05975 19 9.99975V11.9997H17C15.9 11.9997 15 12.8997 15 13.9997V17.9997C15 19.0997 15.9 19.9997 17 19.9997H19V20.9997H13C12.45 20.9997 12 21.4497 12 21.9997C12 22.5497 12.45 22.9997 13 22.9997H18C19.66 22.9997 21 21.6597 21 19.9997V9.99975C21 4.82975 16.64 0.679746 11.4 1.01975Z"
          fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'Headphones',
}
</script>